let recommendedData = [
  {
    id: 1,
    name: "Burnikk",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 240,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2F7l3FMZqY8JdfssalDgx2?alt=media&token=be15689c-e12c-4829-9d78-32395ef1e3f7",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(247, 8, 8)",
      "rgb(9, 225, 182)",
      "rgb(255, 111, 0)",
    ],
    added: false,
    parameter: "7l3FMZqY8JdfssalDgx2",
  },
  {
    id: 2,
    name: "Kibal Batal",
    brand: "Kibal Black",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 674,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FALz5M4DI7MF7CdZrq3gS?alt=media&token=8d33ea34-2de3-466b-9b3d-27015e9cd540",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(253, 138, 8)",
      "rgb(255, 82, 183)",
    ],
    parameter: "ALz5M4DI7MF7CdZrq3gS",
  },
  {
    id: 3,
    name: "Very Nice",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 79,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FLIu8tS4yHSU28Xi8BXCj?alt=media&token=31e796ad-dbd6-4e4f-a8a9-192f5158684a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(3, 215, 252)",
      "rgb(12, 228, 26)",
    ],
    parameter: "LIu8tS4yHSU28Xi8BXCj",
  },
  {
    id: 4,
    name: "Kulangot",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 67,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYIZuxWur1W4fAT6z3ejk?alt=media&token=7dca264f-c345-4cfc-93a8-60217a53f66a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(255, 238, 0)",
      "rgb(0, 240, 8)",
    ],
    added: false,
    parameter: "YIZuxWur1W4fAT6z3ejk",
  },
  {
    id: 5,
    name: "Sipon Malapot",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 250,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYjDAQSbkSZlartelhFyV?alt=media&token=9b0bdd5e-eb91-4d99-a52f-298c12879fa3",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "YjDAQSbkSZlartelhFyV",
  },
  {
    id: 10,
    name: "Pitaklan",
    brand: "Black Kibal",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 174,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FaubOenOJu42CNp4zXTLX?alt=media&token=1d5fd281-b9cc-499b-94a5-225273b1eabc",
    size: [28, 36, 42],
    color: [
      "rgb(247, 73, 64)",
      "rgb(36, 245, 88)",
      "rgb(232, 249, 1)",
      "rgb(47, 53, 244)",
    ],
    added: false,
    parameter: "aubOenOJu42CNp4zXTLX",
  },
];

export default function shareRecommended() {
  return recommendedData;
}
